<template>
    <div>
        <v-content-layout>
            <template #header>
                <el-button icon="el-icon-arrow-left" type="info" @click="() => $router.push('/parsers')">Back</el-button>
                
                <v-spacer></v-spacer>
                <div class="mr-2">
                    <el-input prefix-icon="el-icon-search" placeholder="Search" v-model="search" clearable></el-input>
                </div>
                <v-export-table :disabled="exportStatus" text="Export" :tableColumns="exportHeaders" :tableData="multipleSelection" :filename="`ParsedData-${Date.now()}`" :filesheet="'Sheet1'"></v-export-table>
            </template>
            <template #body>
                <e-table ref="parsedDataTable" :data="itemsByBatchId" :total="itemsByBatchId.length" :headers="headers" :search="search" :height="window.height - 170" :loading="loading" :handleSelectionChange="handleSelectionChange">
                    <template #actions="{scope}">
                        <el-button v-tooltip.top="'View Invoice Items'" size="mini" type="warning" icon="el-icon-view" :disabled="scope.row.invoice_items.length === 0" @click="handleViewInvoiceItems(scope.row)">View Items</el-button>
                    </template>
                    <template #footer>
                        <!-- <el-button type="danger" plain @click="handleClearSelection">Clear Selection</el-button> -->
                    
                        <v-export-table text="Export All w/ Items" :tableColumns="exportHeader" :tableData="exportData" :filename="`ParsedData-${Date.now()}`" :filesheet="'Sheet1'"></v-export-table>
                    </template>
                </e-table>
            </template>
        </v-content-layout>
        <InvoiceItems ref="invoiceItemDialog" />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import * as type from '../../store/types';
import InvoiceItems from './components/InvoiceItems';
export default {
    components: { InvoiceItems },
    data: () => ({
        search: '',
        headers: [],
        multipleSelection: [],
        exportHeader: [],
        exportData: []
    }),
    computed: {
        ...mapGetters({
            itemsByBatchId: 'docparser/itemsByBatchId',
            itemsByInvoice: 'docparser/itemsByInvoice',
            parsedDataLoading: 'docparser/getParsedDataLoading',
            loading: 'global/loading'
        }),
        exportHeaders(){
            return this.headers.map(e => ({ label: e.text, field: e.value })).filter(e => e.label !== '' && e.label !== 'Actions')
        },
        exportStatus(){
            return this.multipleSelection.length > 0 ? false : true;
        }
    },
    created(){
        if(!this.$route.query.parserType || !this.$route.params.id){
            this.$router.push('/parsers')
        }else{
            this.loadParsedResult({ batchId:this.$route.params.id, parserType: this.$route.query.parserType })
            .then(data => {
                this.headers = data.headers
                this.exportHeader = data.exportHeader;
                this.exportData = data.exportData;
            })
            .catch((error) => this.$router.push('/parsers'))
        }
    },
    methods: {
        ...mapActions({
            loadParsedResult: `docparser/${type.DP_GET_PARSED_RESULT_BY_BATCHID}`,
            loadParsedResultData: `docparser/${type.DP_GET_PARSED_DATA_BY_ID}`
        }),
        handleViewInvoiceItems(row){
            this.loadParsedResultData(row.id)
            .then(data => {
                this.$refs['invoiceItemDialog'].handleViewInvoiceItems({invoiceNo: row.invoice_number, ...data})
            })
        },
        handleSelectionChange(val){
            this.multipleSelection = val
        },
        handleClearSelection(){
            this.$refs['parsedDataTable'].handleClearSelection()
        }
    }
}
</script>